import { OP_SEARCH_ITEMS } from '@doda/common/src/constants/searchItems';
import { PickUpConditionListType } from 'types/pickUpConditions';

/**
 * 登録変更画面、検索TOP画面、サイドバー内で「学歴不問」と「転勤なし」の順番がこだわり条件ピックアップと詳細条件で違うため、ピックアップでは順番を入れ替える。
 * @param {PickUpConditionListType[]} pickUpRequirementList
 * @returns pickUpRequirementList
 */
export const changeOrderPickUpRequirement = (
  pickUpRequirementList: PickUpConditionListType[]
) => {
  const noTransferIndex = pickUpRequirementList.findIndex(
    (obj) => obj.id === OP_SEARCH_ITEMS.noTransfer.id
  );
  const noAcademicBackgroundRequiredIndex = pickUpRequirementList.findIndex(
    (obj) => obj.id === OP_SEARCH_ITEMS.noAcademicBackgroundRequired.id
  );

  // 「学歴不問」が「転勤なし」の前にある場合は入れ替えずにそのまま返す
  if (noTransferIndex > noAcademicBackgroundRequiredIndex)
    return pickUpRequirementList;

  [
    pickUpRequirementList[noTransferIndex],
    pickUpRequirementList[noAcademicBackgroundRequiredIndex],
  ] = [
    pickUpRequirementList[noAcademicBackgroundRequiredIndex],
    pickUpRequirementList[noTransferIndex],
  ];

  return pickUpRequirementList;
};
